var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3028 69.9367L67.5323 70.5117L65.8807 79.1358L57.4552 76.6792L52.9498 84.2161L45.8624 79.0208L39.0572 84.5715L34.1755 77.2751L25.8859 80.1497L23.7952 71.6197L15.0144 71.4943L15.9656 62.7657L7.7597 59.6401L11.6379 51.7583L5 46.0193L11.3348 39.9459L7.05932 32.2731L15.098 28.7398L13.6972 20.0739L22.4572 19.499L24.1088 10.8645L32.5448 13.321L37.0502 5.78413L44.1271 10.969L50.9428 5.42871L55.8245 12.7252L64.1141 9.84005L66.2048 18.3805L74.9856 18.5059L74.0344 27.2345L82.2403 30.3601L78.3621 38.2315L85 43.9809L78.6548 50.0543L82.9407 57.7272L74.902 61.2604L76.3028 69.9367Z",
    fill: "url(#paint0_linear_43_2894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3696 44.9946C15.3696 61.3542 28.635 74.63 44.9946 74.63C61.3542 74.63 74.6196 61.3647 74.6196 44.9946C74.6196 28.6246 61.3542 15.3696 44.9946 15.3696C28.635 15.3696 15.3696 28.635 15.3696 44.9946Z",
    fill: "url(#paint1_radial_43_2894)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M49.5105 41.9525C41.9631 35.8268 39.0153 26.5129 42.9249 21.1293C46.8344 15.7458 56.1275 16.3521 63.6749 22.4778C71.2223 28.6035 74.1597 37.928 70.2501 43.301C66.3301 48.6846 57.0474 48.0783 49.5001 41.963L49.5105 41.9525Z",
    fill: "url(#paint2_radial_43_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M18.809 51.5488C19.8126 48.2769 24.8929 49.6254 30.1614 54.5803C35.43 59.5352 38.9005 66.2045 37.897 69.4868C36.9039 72.7588 31.8131 71.4103 26.5446 66.4554C21.276 61.5004 17.8055 54.8312 18.809 51.5488Z",
    fill: "url(#paint3_radial_43_2894)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_2894",
    x1: 81.4772,
    y1: 4.23702,
    x2: 11.1675,
    y2: 82.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_43_2894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7789 26.4189) rotate(-180) scale(56.2498 56.2498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_43_2894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.222 -181.712) rotate(126.03) scale(12.0783 17.5684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_43_2894",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.571 497.15) rotate(-136.79) scale(13.1106 5.53738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherSun);
export default __webpack_public_path__ + "static/media/weather-sun.774bc84216494890c11c8b45bae9ee89.svg";
export { ForwardRef as ReactComponent };